import { Loader } from '@/shared/components/common/Loader';
import React, { useCallback, useMemo, useState } from 'react';
import { LoaderContext } from './loaderContextValue';

interface LoaderProviderProps {
  children: React.ReactNode;
}

export const LoaderProvider: React.FC<LoaderProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [activeRequests, setActiveRequests] = useState(0);

  const showLoader = useCallback(() => {
    setActiveRequests((prev) => {
      const newCount = prev + 1;
      setIsLoading(newCount > 0);
      return newCount;
    });
  }, []);

  const hideLoader = useCallback(() => {
    setActiveRequests((prev) => {
      const newCount = Math.max(0, prev - 1);
      setIsLoading(newCount > 0);
      return newCount;
    });
  }, []);

  const value = useMemo(
    () => ({
      showLoader,
      hideLoader,
      isLoading,
      activeRequests,
    }),
    [showLoader, hideLoader, isLoading, activeRequests],
  );

  return (
    <LoaderContext.Provider value={value}>
      {children}
      <Loader isLoading={isLoading} />
    </LoaderContext.Provider>
  );
};
